const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');
const ListTable = require('app/ui/list/Table');
const Modal = require('app/ui/Modal');
const ConfirmModal = require('app/ui/modal/Confirm');

const PaymentForm = require('app/billing/payment/Form');
const ExportModal = require('app/billing/payment/export/Modal');

class ReceivedTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'invoice': null,
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);
        this.buildFooter = this.buildFooter.bind(this);
        this.onSubmitFilterForm = this.onSubmitFilterForm.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.invoice = this.settings.invoice;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.$content = $('<div/>')
        .append(window.App.generateLoader());

        this.$container
        .html('')
        .append(this.$content);

        this.loadData();
    }

    onDOMReady(){

        window.select2(this.$filterByRestaurant);
    }

    loadData(){
        var self = this;

        let queries = [
            this.buildRestaurantQuery(),
            this.buildPaymentTypeQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.buildTab(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();

    }

    buildRestaurantQuery(){
        var self = this;

        let filters = {
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'restaurants',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildPaymentTypeQuery(){
        var self = this;


        let filters = {
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'billingPaymentTypes',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildTab(data){
        this.restaurants = data.restaurants.edges;
        this.types = data.billingPaymentTypes.edges;

        this.$tableContainer = $('<div/>')
        .addClass('white-box');

        this.$content
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-9 p-2')
                .append(this.$tableContainer)
            )
            .append(
                $('<div/>')
                .addClass('col-3 p-2')
                .append(this.buildActionContainer())
                .append(
                    $('<div/>')
                    .addClass('white-box')
                    .append(
                        $('<h3/>')
                        .addClass("box-title")
                        .append(window.translate('filters'))
                    )
                    .append( this.buildFilterForm())
                )
            )
        )

        this.initializeListTable();

        this.onDOMReady();
    }

    buildActionContainer(){
        var self = this;

        this.$btnExportPdf = $('<button/>')
        .addClass('btn btn-sm btn-info btn-export')
        .attr('data-format','pdf')
        .append(
            $('<i/>')
            .addClass('fas fa-file-pdf me-1')
        )
        .append(window.translate('exportPDF'))
        .on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let $btn = $(this);
            self.onClickBtnExport($btn);
        });


        this.$btnExportExcel = $('<button/>')
        .addClass('btn btn-sm btn-info btn-export')
        .attr('data-format','excel')
        .append(
            $('<i/>')
            .addClass('fas fa-file-excel me-1')
        )
        .append(window.translate('exportExcel'))
        .on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let $btn = $(this);
            self.onClickBtnExport($btn);
        });


        let $actions = $('<ul/>')
        .addClass('list-unstyled')
        .append(
            $('<li/>')
            .addClass('p-2')
            .append(this.$btnExportPdf)
        )
        .append(
            $('<li/>')
            .addClass('p-2')
            .append(this.$btnExportExcel)
        );

        let $container = $('<div/>')
        .addClass('white-box')
        .append(
            $('<h3/>')
            .addClass("box-title")
            .append("Actions")
        )
        .append($actions);

        return $container;
    }

    buildFilterForm(){
        this.$filterForm = $('<form/>')
        .addClass('billing-payment-search-form');

        let from = moment().startOf('month').format('YYYY-MM-DD');
        this.$filterByDateFrom = $('<input/>')
        .attr('type','date')
        .attr('name','from')
        .addClass('form-control')
        .val(from);
        this.$filterForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for',"from")
                .append(window.translate('app.billing.payment.list.tabs.received.search.byDate.from'))
            )
            .append(this.$filterByDateFrom)
        )

        let to = moment().endOf('month').format('YYYY-MM-DD');
        this.$filterByDateTo = $('<input/>')
        .attr('type','date')
        .attr('name','to')
        .addClass('form-control')
        .val(to);
        this.$filterForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for',"to")
                .append(window.translate('app.billing.payment.list.tabs.received.search.byDate.to'))
            )
            .append(this.$filterByDateTo)
        )

        this.$filterByRestaurant = $('<select/>')
        .attr('id','restaurant')
        .attr('name','restaurant')
        .addClass('form-control')
        .append(
            $('<option/>')
            .val('')
            .append('-')
        );
        for(var i in this.restaurants){
            let type = this.restaurants[i].node;
            this.$filterByRestaurant
            .append(
                $('<option/>')
                .val(type.id)
                .append(type.name)
            )
        }
        this.$filterForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for',"restaurant")
                .append(window.translate('app.billing.payment.list.tabs.received.search.byRestaurant.label'))
            )
            .append(this.$filterByRestaurant)
        )

        this.$filterByType = $('<select/>')
        .attr('id','type')
        .attr('name','type')
        .addClass('form-control')
        .append(
            $('<option/>')
            .val('')
            .append('-')
        );
        for(var i in this.types){
            let type = this.types[i].node;
            this.$filterByType
            .append(
                $('<option/>')
                .val(type.id)
                .append(type.name)
            )
        }
        this.$filterForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for',"type")
                .append(window.translate('app.billing.payment.list.tabs.received.search.byType.label'))
            )
            .append(this.$filterByType)
        )


        this.$filterByInvoice = $('<input/>')
        .attr('type','text')
        .attr('name','invoice')
        .addClass('form-control');
        this.$filterForm
        .append(
            $('<div/>')
            .addClass('form-group')
            .append(
                $('<label/>')
                .attr('for',"from")
                .append(window.translate('app.billing.payment.list.tabs.received.search.byInvoice.label'))
            )
            .append(this.$filterByInvoice)
        )

        this.$filterByDateFrom.on('change',this.onSubmitFilterForm);
        this.$filterByDateTo.on('change',this.onSubmitFilterForm);
        this.$filterByRestaurant.on('change',this.onSubmitFilterForm);
        this.$filterByType.on('change',this.onSubmitFilterForm);
        this.$filterByInvoice.on('change',this.onSubmitFilterForm);

            this.$filterForm.on('submit',this.onSubmitFilterForm);

        return this.$filterForm;
    }

    onSubmitFilterForm(event){
        event.preventDefault()
        event.stopPropagation();

        this.table.refresh();
    }

    refresh(){
        this.table.refresh();
    }

    initializeListTable(){
        var self = this;

        let fields = [
            'id',
            'type { id name }',
            'date',
            'invoiceAssociations { invoice { id reference customerName } amount }',
            'amount'
        ];

        this.table = new ListTable({
            '$container': this.$tableContainer,
            'tableClass': 'table table-striped billing-payment-list',
            'footerBuilder': {
                'mode': 'custom',
                'render': this.buildFooter,
            },
            'showPagination': false,
            'id': 'list-billing-payments',
            'length': 0,//leave 0 to show all and retrieve all 
            'graphQL': {
                'queryType': 'billingPayments',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'type',
                    'label': window.translate('billing.payment.type.label'),
                    'class': 'billing-payment-type',
                    'render': function(item,index){
                        return item.node.type.name;
                    },
                },
                {
                    'name': 'invoiceAssociations',
                    'label': window.translate('billing.payment.invoiceAssociations.label'),
                    'class': 'billing-payment-invoiceAssociations',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-unstyled');
                        let invoiceAssociations = item.node.invoiceAssociations;
                        if(!invoiceAssociations){
                            invoiceAssociations = [];
                        }
                        for(var i in invoiceAssociations){
                            let invoiceAssociation = invoiceAssociations[i];
                            let amount = window.formatFloat(invoiceAssociation.amount) + ' &euro;';
                            let label = ' <strong>'+invoiceAssociation.invoice.reference+'</strong> '+invoiceAssociation.invoice.customerName+' ('+amount+')';
                            $list
                            .append(
                                $('<li/>')
                                .append(label)
                            )
                        }
                        return $list;
                    },
                },
                {
                    'name': 'date',
                    'label': window.translate('billing.payment.date.label'),
                    'class': 'billing-payment-date',
                    'render': function(item,index){
                        return window.formatDate(item.node.date,window.translate('momentDateFormat.fullDay'));
                    },
                },
                {
                    'name': 'amount',
                    'label': window.translate('billing.payment.amount.label'),
                    'class': 'billing-payment-amount',
                    'render': function(item,index){
                        return window.formatFloat(item.node.amount) + ' &euro;';
                    },
                },
                {
                    'name': 'actions',
                    'label': '',
                    'class': 'billing-payment-actions',
                    'render': function(item,index){
                        let $list = $('<ul/>')
                        .addClass('list-inline btn-list-inline');

                        let btns = [];

                        let $btnEdit = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-link text-primary')
                        .attr('title',window.translate('app.billing.payment.list.tabs.received.actions.edit.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-edit')
                        )
                        .on('click',function(event){
                            let $btn = $(this);
                            self.onClickEdit(item.node);
                        });
                        btns.push($btnEdit);


                        let $btnDelete = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-link text-danger')
                        .attr('title',window.translate('app.billing.payment.list.tabs.received.actions.delete.label'))
                        .append(
                            $('<i/>')
                            .addClass('fas fa-trash')
                        )
                        .on('click',function(event){
                            let $btn = $(this);
                            self.onClickDelete(item.node);
                        });
                        btns.push($btnDelete);

                        for(var i in btns){
                            let $btn = btns[i];
                            $list.append(
                                $('<li/>')
                                .addClass('list-inline-item')
                                .append($btn)
                            );
                        }

                        return $list;
                    },
                },

            ]
        })
    }

    buildFooter(data){
        let $row = $('<tr/>');

        if(data.length <= 1){
            return '';
        }

        let total = 0;

        for(var i in data){
            let item = data[i].node;
            total += parseFloat(item.amount);
        }

        $row
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )
        .append(
            $('<td/>')
            .append(window.translate('total'))
        )
        .append(
            $('<td/>')
            .append(window.formatFloat(total) + ' &euro;')
        )
        .append(
            $('<td/>')
            .append("&nbsp;")
        )

        return $row;
    }

    buildGraphQLParameters(){
        let filters = {

        };

        if(this.$filterByInvoice.val()){
            filters.invoiceReference = this.$filterByInvoice.val();
        }
        else{
            if( this.$filterByDateFrom.val() && this.$filterByDateTo.val()){
                let from = this.$filterByDateFrom.val();
                let to = this.$filterByDateTo.val();

                filters.date = 'BETWEEN '+from+' '+to;
            }
            if(this.$filterByType.val()){
                filters.type = parseInt(this.$filterByType.val());
            }

            if(this.$filterByRestaurant.val()){
                filters.restaurant = parseInt(this.$filterByRestaurant.val());
            }
        }

        let orderBy = 'date';
        let dir = "ASC";

        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    onClickEdit(payment){
        var self = this;
        let form = new PaymentForm({
            'payment': payment,
            'invoice': null,
            'success': function(){
                self.paymentModal.dispose();
                self.refresh();
            }
        });

        this.paymentModal = new Modal({
            'title': window.translate('app.billing.payment.form.edit.title'),
            'modalSize': 'xxl',
            'content': form.getForm()
        });

        this.paymentModal.show();
    }

    onClickDelete(payment){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.billing.payment.list.tabs.received.actions.delete.confirm'))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event,modal){
                self.proceedDelete(payment,modal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();

    }

    proceedDelete(payment,confirmModal){

        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'id': {
                'value': payment.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteBillingPayment",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                confirmModal.hide();
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.hide();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }

    onClickBtnExport($btn){

        let format = $btn.data('format');

        let modal = new ExportModal({
            'format': format,
            'parameters': this.buildGraphQLParameters(),
        });
    }

}

module.exports = ReceivedTab;

